/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ClaimGroupService extends services.DataService<Wars.Domain.Model.ClaimGroup> {
        
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getGlaimGroup(id: string): ng.IPromise<Wars.Domain.Model.ClaimGroup> {
            return this.fetchById(id, "ClaimGroup");
        }

        public createNewClaimGroup(): Wars.Domain.Model.ClaimGroup {
            var newClaimGroup = this.createNewEntity<Wars.Domain.Model.ClaimGroup>("ClaimGroup");
            return newClaimGroup;
        }
    }
}

warsApp.registerService('ClaimGroupService', ['breeze', '$q']);